import Cookies from 'js-cookie';
import moment from 'moment';
import { AuthenticationResult } from '../types';

export const setToken = (AuthenticationResult: AuthenticationResult) => {
  if (AuthenticationResult) {
    const now = moment();
    const expiry = now.clone().add(30, 'days'); // hết hạn sau 30 ngày
    Cookies.set('liemlanAccessToken', AuthenticationResult.accessToken, { expires: 30 });
    if (AuthenticationResult.refreshToken) {
      Cookies.set('liemlanRefreshToken', AuthenticationResult.refreshToken, { expires: 30 });
    }
    Cookies.set('liemlanLoginDate', now.format('YYYY-MM-DD HH:mm:ss'), { expires: 30 });
    Cookies.set('liemlanExpiryDate', expiry.format('YYYY-MM-DD HH:mm:ss'), { expires: 30 });
    Cookies.set('liemlanRemember', AuthenticationResult?.remember ? 'true' : 'false', { expires: 30 });
  }
};
export const setAccessToken = (accessToken: string) => {
  if (accessToken) {
    Cookies.set('liemlanAccessToken', accessToken, { expires: 30 });
  }
};
export const getAccessToken = (): string | undefined => {
  return Cookies.get('liemlanAccessToken');
};

export const getRefreshToken = (): string | undefined => {
  return Cookies.get('liemlanRefreshToken');
};

export const getRemember = (): boolean => {
  return Cookies.get('liemlanRemember') === 'true';
};
export const getAuthenticationResult = (): AuthenticationResult => {
  return {
    accessToken: Cookies.get('liemlanAccessToken') ?? '',
    refreshToken: Cookies.get('liemlanRefreshToken') ?? '',
    LoginDate: Cookies.get('liemlanLoginDate') ?? '',
    ExpiryDate: Cookies.get('liemlanExpiryDate') ?? '',
  };
};

export const removeToken = () => {
  Cookies.remove('liemlanAccessToken');
  Cookies.remove('liemlanRefreshToken');
  Cookies.remove('liemlanLoginDate');
  Cookies.remove('liemlanRemember');
  Cookies.remove('liemlanExpiryDate');
};
